import { yup } from '@framework/validation/initYup.ts';
import { type YupAnyObjectSchema } from '@framework/validation/YupObjectSchema.ts';

/**
 * Dato lo schema delle sezioni di un modulo e una lista di ID di sezioni,
 * restituisce lo stesso schema in cui le sezioni indicate sono sostituite con
 * `yup.mixed()` (passthrough). In questo modo i valori di tali sezioni vengono
 * preservati senza essere modificati né validati.
 *
 * Utilizzato per esempio per gestire le shared sections dove i valori della sezione condivisa
 * non devono essere modificati né validati, ma semplicemente preservati per mantenere le logiche.
 */
export function replaceSectionsSchemaWithMixed(
  sectionsSchema: YupAnyObjectSchema,
  sectionIds: string[],
): YupAnyObjectSchema {
  if (sectionIds.length === 0) return sectionsSchema;

  const overrides = Object.fromEntries(sectionIds.map(id => [id, yup.mixed()]));

  return sectionsSchema.shape(overrides);
}
